import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// 导入统一的 dayjs 配置
import "./utils/dayjsConfig";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<App />);
